import { useContext } from 'react';
import { Context } from './Context';

export const useMapContext = () => {
  const context = useContext(Context);
  if (!context) {throw new Error('No map context found. Is there a wrapping Provider component?');}
  return context;
};
